export const PROFILE_COMPLETION_DISMISSED_KEY = 'profileCompletionDismissed'
